<template>
  <b-field
    :label="label"
    :type="(hasError() ? 'is-danger': '')"
    :message="errorMessage()"
  >
    <b-datepicker
      :position="position"
      :value="date"
      :locale="$laravel.app.locale"
      :placeholder="$t('click_or_select_date')"
      icon="calendar-today"
      :class="{'is-danger': hasError()}"
      :disabled="disabled"
      :min-date="minDate"
      :append-to-body="appendToBody"
      @input="onInput"
    />
  </b-field>
</template>

<script>

import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === "string" || prop === null
    },
    position: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    minDate: {
      type: Date,
      default: null
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      date: null
    };
  },
  created () {
    this.date = this.dateParser(this.value);
  },
  methods: {
    onInput (payload) {
      this.inputListener(this.$luxon.fromJSDate(payload).toFormat("y-LL-dd"));
    },
    dateParser(date) {
      if (date !== null) {
        return this.$luxon.fromISO(date).toJSDate();
      }

      return null;
    }
  }
};
</script>
